export type UserWarningSeverity = 'LOW' | 'MEDIUM' | 'HIGH';

export class UserWarningModel {
    user_warning_id: number;
    user_id: number;
    warning_date: string | Date;
    reason: string;
    description: string | null;
    severity: UserWarningSeverity;
    created_by_user_id: number | null;
    createdAt: Date;

    constructor(data?: Partial<UserWarningModel>) {
        this.user_warning_id = data?.user_warning_id ?? null;
        this.user_id = data?.user_id ?? null;
        this.warning_date = data?.warning_date ?? null;
        this.reason = data?.reason ?? null;
        this.description = data?.description ?? null;
        this.severity = data?.severity ?? null;
        this.created_by_user_id = data?.created_by_user_id ?? null;
        this.createdAt = data?.createdAt ?? null;
    }
}
